// extracted by mini-css-extract-plugin
module.exports = {"clickableRow":"SearchTable_clickableRow_h4Tpm","clickableCell":"SearchTable_clickableCell_3PKlO","clickableAnchor":"SearchTable_clickableAnchor_VVPJT"};